// import axios from 'axios';

// const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// axios.defaults.baseURL = API_BASE;
// axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true';

// export default API_BASE;

import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: {
    'ngrok-skip-browser-warning': 'true',
  },
});

export default api;